import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, effect, inject, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private platformId = inject(PLATFORM_ID);
  private doc = inject(DOCUMENT);

  isDark = signal(this.getInitialTheme());

  constructor() {
    effect(() => {
      const dark = this.isDark();
      if (isPlatformBrowser(this.platformId)) {
        this.doc.documentElement.classList.toggle('dark', dark);
        localStorage.setItem('theme', dark ? 'dark' : 'light');
      }
    });
  }

  private getInitialTheme(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    if (typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  toggle() {
    this.isDark.update(v => !v);
  }
}
